// project-imports
import {
    GET_GALLERY_DATA_BEGIN, GET_GALLERY_DATA_SUCCESS, GET_GALLERY_DATA_FAILURE,
    GET_POPULAR_VIDEO_BEGIN,
    GET_POPULAR_VIDEO_SUCCESS,
    GET_POPULAR_VIDEO_FAILURE,
    GET_POPULAR_SHORTS_BEGIN,
    GET_POPULAR_SHORTS_SUCCESS,
    GET_POPULAR_SHORTS_FAILURE,
    GET_POPULAR_LIVE_VIDEO_BEGIN,
    GET_POPULAR_LIVE_VIDEO_SUCCESS,
    GET_POPULAR_LIVE_VIDEO_FAILURE,
    GET_LAST_TWO_WEEK_TRENDING_VIDEOS_BEGIN,
    GET_LAST_TWO_WEEK_TRENDING_VIDEOS_SUCCESS,
    GET_LAST_TWO_WEEK_TRENDING_VIDEOS_FAILURE,
    GET_LATEST_VIDEO_BEGIN,
    GET_LATEST_VIDEO_SUCCESS,
    GET_LATEST_VIDEO_FAILURE,
} from "../constants/actions";

// State variable initialization
export const initialState = {
    isLoading: false,
    isError: null,
    galleryLoading: false,
    galleryError: null,
    galleryData: [],
    popularVideos: [],
    popularShorts: [],
    popularLiveVideos: [],
    lastWeekTrendingVideos: [],
    latestVideos: [],
};

const galleryReducer = (state = initialState, action) => {

    if (action.type === GET_GALLERY_DATA_BEGIN) {
        // Set loading state
        return {
            ...state,
            galleryLoading: action.payload,
            galleryError: null,
        };
    }

    if (action.type === GET_GALLERY_DATA_SUCCESS) {
        const filteredData = action.payload?.filter(item =>
            item?.playlistName?.includes("Salesforce Data Cloud Series") ||
            item?.playlistName?.includes("Salesforce Live")
        );
        // Update state with all data
        return {
            ...state,
            galleryLoading: false,
            galleryData: filteredData,
            galleryError: null,
        };
    }

    if (action.type === GET_GALLERY_DATA_FAILURE) {
        // Set error state
        return {
            ...state,
            galleryLoading: false,
            galleryError: action.payload,
        };
    }

    // Popular Videos
    if (action.type === GET_POPULAR_VIDEO_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_POPULAR_VIDEO_SUCCESS) {
        // Update state with all data
        return {
            ...state,
            isLoading: false,
            popularVideos: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_POPULAR_VIDEO_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            isError: action.payload,
        };
    }

    // Popular Shorts
    if (action.type === GET_POPULAR_SHORTS_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_POPULAR_SHORTS_SUCCESS) {
        // Update state with all data
        return {
            ...state,
            isLoading: false,
            popularShorts: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_POPULAR_SHORTS_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            isError: action.payload,
        };
    }

    // Popular Live Videos
    if (action.type === GET_POPULAR_LIVE_VIDEO_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_POPULAR_LIVE_VIDEO_SUCCESS) {
        // Update state with all data
        return {
            ...state,
            isLoading: false,
            popularLiveVideos: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_POPULAR_LIVE_VIDEO_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            isError: action.payload,
        };
    }
    // get Last 2-week Trending videos
    if (action.type === GET_LAST_TWO_WEEK_TRENDING_VIDEOS_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_LAST_TWO_WEEK_TRENDING_VIDEOS_SUCCESS) {
        // Update state with all data
        return {
            ...state,
            isLoading: false,
            lastWeekTrendingVideos: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_LAST_TWO_WEEK_TRENDING_VIDEOS_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            isError: action.payload,
        };
    }

    // Latest Videos
    if (action.type === GET_LATEST_VIDEO_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_LATEST_VIDEO_SUCCESS) {
        // Update state with all data
        return {
            ...state,
            isLoading: false,
            latestVideos: action.payload,
            isError: null,
        };
    }

    if (action.type === GET_LATEST_VIDEO_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            isError: action.payload,
        };
    }
    return state;

};

export default galleryReducer;
